import { UploadFileVariant } from './UploadAgreement.styles';
import { ProgressVariant } from '../../../../../../../CommonComponents/OPL/Progress/Progress.styles';

/**
 * For files with names with an higher number of chars -> truncate with ellipses in the middle
 */
export const TRUNCATE_UPLOADING_FILE_NAME_THRESHOLD = 30;

export const iconMap: Record<UploadFileVariant, string> = {
  uploading: 'far fa-times-circle',
  completed: 'fas fa-check-circle',
  error: 'fas fa-times-octagon',
  cancelled: 'fas fa-times-octagon',
};

export const progressVariantMap: Record<UploadFileVariant, ProgressVariant> = {
  uploading: 'primary',
  completed: 'success',
  error: 'error',
  cancelled: 'neutral',
};
